<template>
  <modal-container>
    <modal-form-edit
      v-if="userLimit > 1"
      ref="UserInviteFormModal"
      title="Users"
      form-component="user-invite-form"
      save-button-label="Invite to Forefront"
      :hide-save-button="!hasAvailableUsers"
      hide-delete-button
      on-close-clear-query
      @saved="handleNewInvite"
    >
      <users-active-users/>

      <users-third-party-users v-if="hasThirdPartyUsers"/>

      <users-deactivated-users :invited-user-count.sync="invitedUsers.length"/>

      <users-pending-invites
        v-if="hasInviteFeature"
        :is-loading="inviteLoading"
        :users.sync="invitedUsers"
      />
    </modal-form-edit>

    <modal-default
      v-else
      title="Users"
      ref="UserInviteFormModal"
      @close="closeModal"
    >
      <div>
        <p class="upgrade_message--content"><a @click="openBillingPortal">Upgrade your account today</a> and be able to
          invite your team to work with you in Forefront.</p>
        <p class="upgrade_message--content">As you get more successful and do more deals you'll need to grow your team.
          With Forefront you can do so with ease.</p>
        <p class="upgrade_message--content">You'll be able to keep everyone on the same page, make sure things
          don't fall thru the cracks, and make sure everyone is performing well.</p>

        <div class="flex flex-centered mt-100">
          <button-outlined @click="openBillingPortal">Upgrade Your Account</button-outlined>
        </div>
      </div>
    </modal-default>
  </modal-container>
</template>

<script>
import UsersActiveUsers from './components/UsersActiveUsers';
import UsersDeactivatedUsers from './components/UsersDeactivatedUsers';
import UsersPendingInvites from './components/UsersPendingInvites';
import dates from "../../services/dates";
import UsersThirdPartyUsers from "./components/UsersThirdPartyUsers.vue";

export default {
  name: "UsersModal",
  components: {
    UsersThirdPartyUsers,
    UsersActiveUsers,
    UsersDeactivatedUsers,
    UsersPendingInvites
  },
  data() {
    return {
      invitedUsers: [],
      inviteLoading: false
    }
  },
  watch: {
    '$route' () {
      this.openModal();
    },
  },
  mounted() {
    this.openModal();
  },
  computed: {
    hasThirdPartyUsers() {
      return !!this.$store.getters.thirdPartyUsers.length;
    },
    hasInviteFeature() {
      return this.$store.state.accounts.features.InviteUsers
    },
    userCount() {
      return this.$store.getters.activeUsers.length;
    },
    userLimit() {
      return this.$store.getters.account.user_limit;
    },
    hasAvailableUsers() {
      return this.hasInviteFeature && this.userCount < this.userLimit;
    },
  },
  methods: {
    getPendingInvites() {
      if (! this.hasInviteFeature) return

      this.inviteLoading = true;
      this.$api.userInvites.all()
        .then(res => {
          this.invitedUsers = res.data.filter(invite => dates.isTodayOrInFuture(invite.expires_at));
        })
        .finally(() => this.inviteLoading = false);
    },
    handleNewInvite(user) {
      this.invitedUsers.push(user);
    },
    openModal() {
      if (this.$route.query.modal === 'users') {
        this.$refs.UserInviteFormModal.open();
        this.getPendingInvites();
      }
    },
    closeModal() {
      this.$router.replace({...this.$router.currentRoute, query: ''});
    },
  }
}
</script>

<style lang="scss">

.upgrade_message {

  &--content {
    margin-bottom: 10px;
    line-height: 1.4;
  }
}
</style>
